"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHostedBrand = isHostedBrand;

var _runtimeConfigHelper = require("./runtime-config-helper");

function isHostedBrand() {
  return (0, _runtimeConfigHelper.getRuntimeConfig)()._brand.toLowerCase() === 'endurance';
}